<template>

  <ul class="nav navbar-top-links navbar-right">
    <li>
      
    </li>

    <li class="dropdown">
      <a class="dropdown-toggle count-info" data-toggle="dropdown" href="#">
        <span class="m-r-sm text-muted welcome-message">Welcome {{ mainUsername + (mainProfileCurrent ? ` (${mainProfileCurrent.title})` : '') }}</span>
        
        <i class="fa fa-user"></i>
        <span class="label label-warning">{{ meRoles.length }}</span>
      </a>

      <ul class="dropdown-menu dropdown-messages">
        <li
          v-for="role of meRoles" v-bind:key="role.id">
          <div 
            v-on:click="onProfileClick(role)">
            <div
              v-bind:class="helper.compareID(role.roleID, roleID) && helper.compareID(role.customerID, customerID) ? 'bg-light' : ''"
              class="dropdown-messages-box"
              style="padding: 10px">
              <small class="float-right" v-html="getRoleCardAgo(role)"></small>
              <strong v-html="getRoleCardTitle(role)"></strong>
              <div v-html="getRoleCardText1(role)"></div>
              <div v-html="getRoleCardText2(role)"></div>
              <small class="text-muted" v-html="getRoleCardLastLogin(role)"></small>
            </div>
          </div>
          <div class="dropdown-divider"></div>
        </li>
        <!-- last list item will have skewed margin? -->
        <li></li>
      </ul>
    </li>

    <li class="dropdown">
      <a class="dropdown-toggle count-info" data-toggle="dropdown" href="#">
        <i class="fa fa-product-hunt"></i>
      </a>

      <!--
      <div class="dropdown-menu dropdown-alerts">
        <div class="row">
          <div 
            class="col-4" 
            v-for="service in mainServices" 
            v-bind:key="service.title"
            v-on:click="onServiceClick(service.url)">
            <div
              class="dropdown-messages-box"
              style="text-align:center; padding: 10px">
              <img alt="image" class="rounded-circle" v-bind:src="service.image">
              <div class="mt-1">
                <strong>{{ service.title }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
      -->

    </li>

    <li>
      <a v-bind:href="helper.WEB_URL + '/logout'">
        <i class="fa fa-sign-out"></i> Log out
      </a>
    </li>
  </ul>

</template>

<script>
import helper from "@/components/Utility/Helper"

var moment = require('moment');

export default {
  name: "TemplateMain",
  components: {
  },
  data() {
    return {
      helper: helper,
      mainUsername: '',
      meRoles: '',
      roleID: '',
      customerID: '',
      mainProfileCurrent: '',

      mainServices: [
        {
          title: 'Provision',
          url: 'https://provision.parkaidemobile.com/redirect',
          image: '/static/image/icon_provision.png',
        },
        {
          title: 'ParkAide',
          url: 'https://pa.parkaidemobile.com/',
          image: '/static/image/icon_parkaide.png',
        },
        // {
        //   title: 'ParkBills',
        //   url: 'https://parkbills.parkaidemobile.com/redirect',
        //   image: '/static/image/icon_parkbill.png',
        //   // url: '/redirect',
        // },
      ],
      // meRolesSelected: {},
    };
  },
  created() {
    this.mainUsername = JSON.parse(localStorage.getItem('user')).username;
    this.meRoles = JSON.parse(localStorage.getItem('meRoles'));
    this.meRoles.forEach(k => {
      k['lastLogin'] = k['lastLogin'] || this.randomDate(moment().add(-3, 'days'), moment());
      k['lastLoginAgo'] = k['lastLogin'].fromNow();
      k['lastLoginTime'] = helper.formatTime(k['lastLogin']);
      k['lastLoginDate'] = helper.formatDate(k['lastLogin']);
    })
    this.roleID = localStorage.getItem('selectedRoleID');
    this.customerID = localStorage.getItem('selectedCustomerID');
    this.operatorID = localStorage.getItem('selectedOperatorID');
    this.mainProfileCurrent = this.meRoles.find(k => helper.compareID(k.roleID, this.roleID) && helper.compareID(k.customerID, this.customerID) && helper.compareID(k.operatorID, this.operatorID));
  },
  methods : {
    randomDate(start, end) {
      return new moment.unix(start.unix() + Math.random() * (end.unix() - start.unix()));
    },
    onProfileClick(profile) {
      helper.chooseRole(this, profile, true);
    },
    onServiceClick(serviceUrl) {
      window.open(serviceUrl + '?email=' + this.mainUsername + '&jwt=' + JSON.parse(localStorage.getItem('user')).jwt, '_blank');
    },

    getRoleCardTitle(role) {
      if(role.type) {
        if(role.type === 'Personal') {
          return 'Parker Account';
        } else if(role.type === 'Company') {
          return 'Add Company Account';
        } else if(role.type === 'Operator') {
          return 'Operator Account';
        } else if(role.type === 'Parker') {
          return 'Season Account';
        } else {
          return 'Operator Account';
        }
      }
      return 'Account'
    },
    getRoleCardText1(role) {
      if(role.type) {
        if(role.type === 'Personal') {
          return 'Season Parker';
        } else if(role.type === 'Company') {
          if(role.customerID) {
            return 'Season Parker';
          } else {
            return '';
          }
        } else if(role.type === 'Operator') {
          return role.operatorName;
        }
      }

      return role.operatorName;
    },
    getRoleCardText2(role) {
      if(role.type) {
        if(role.type === 'Personal') {
          return '';
        } else if(role.type === 'Company') {
          if(role.customerID) {
            return '';
          } else {
            return '';
          }
        } else if(role.type === 'Operator') {
          return '<i class="fa fa-star"></i> ' + role.title;
        }
      }

      return '<i class="fa fa-star"></i> ' + role.title;
    },

    getRoleCardAgo(role) {
      if(role.type) {
        if(role.type === 'Personal') {
          return role.lastLoginAgo;
        } else if(role.type === 'Company') {
          if(role.customerID) {
          return role.lastLoginAgo;
          } else {
            return '';
          }
        } else if(role.type === 'Operator') {
          return role.lastLoginAgo;
        }
      }

      return role.lastLoginAgo;
    },
    getRoleCardLastLogin(role) {
      if(role.type) {
        if(role.type === 'Personal') {
          return 'Last login ' + role.lastLoginTime + ' - ' + role.lastLoginDate;
        } else if(role.type === 'Company') {
          if(role.customerID) {
            return 'Last login ' + role.lastLoginTime + ' - ' + role.lastLoginDate;
          } else {
            return '';
          }
        } else if(role.type === 'Operator') {
          return 'Last login ' + role.lastLoginTime + ' - ' + role.lastLoginDate;
        }
      }

      return 'Last login ' + role.lastLoginTime + ' - ' + role.lastLoginDate;
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Template/TemplateProfile.vue